import { ForeclosureStateType as GqlForeclosureStateType } from '@willow/graphql-iso/src/app';
import { assertNever, ForeclosureStateType } from '@willow/types-iso';

export function formatForeclosureStateType(stateType: ForeclosureStateType): string;
export function formatForeclosureStateType(stateType: GqlForeclosureStateType): string;
export function formatForeclosureStateType(stateType: ForeclosureStateType | GqlForeclosureStateType): string {
  switch (stateType) {
    case 'judicial':
    case GqlForeclosureStateType.Judicial:
      return 'Judicial';
    case 'nonJudicial':
    case GqlForeclosureStateType.NonJudicial:
      return 'Non-Judicial';
    default:
      assertNever(stateType);
  }
}
